import { PreviewFragment } from '@/media/types/PreviewResponse';
import { BaseProductType } from '@/product/constants/productTypes';

export const FRAGMENTS_COUNT = 4;

export function buildProductTypeFragments(productType?: Nullable<BaseProductType>): PreviewFragment[] {
  if (!productType) {
    return [];
  }

  return Array.from({ length: FRAGMENTS_COUNT }, () => ({ url: null, placeholder: { type: productType } }));
}
